import {
  GENERAL_CHANGE_VALUES,
} from '@shared/store/constants/mutationTypes';

const mutations = {
  [GENERAL_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
};

export default mutations;
